/* eslint-disable @next/next/no-img-element */
import { Block, Typography } from "@xprog/prensa";
import React from "react";
import find from "lodash/find";
import isArray from "lodash/isArray";

import SectionTitle from "components/SectionTitle";

import {
  CloseProps,
  TitleOpenProps,
  SubjectProps,
  TitleProps,
  TitlePropsExpanded,
  Thumbnail,
} from "./styled";
import { VideoWrap } from "components/Video";
import { useAutoRefresh } from "hooks/useAutoRefresh";

type VideoLiveProps = {
  children?: any;
  className?: string;
  customProps?: {
    className?: string;
  };
  slotTemplateCode?: string;
  contentData?: {
    byline?: string;
    url?: string;
  };
  name?: string;
  title?: string;
  thumbnail?: string;
};

export const VideoLiveWrap: React.FC<any> = (props) => {
  const firstEmbedItem = find(props?.items, {
    inputTemplate: "br.com.atex.templates.articleEmbed.it",
  });
  const firstVideoItem = find(props?.items, {
    inputTemplate: "br.com.atex.templates.articleVideo.it",
  });
  let embedSelected;
  if (firstVideoItem) {
    embedSelected = firstVideoItem;
  } else if (firstEmbedItem) {
    embedSelected = firstEmbedItem;
  }
  if (!embedSelected) {
    return <></>;
  }
  return <VideoLive {...embedSelected} />;
};

const VideoLive: React.FC<VideoLiveProps> = (props) => {
  const { enableAutoRefresh, disableAutoRefresh } = useAutoRefresh();
  const [isExpanded, setIsExpanded] = React.useState(false);

  const handleExpand = () => {
    setIsExpanded(!isExpanded);
  };

  React.useEffect(() => {
    if (isExpanded) {
      disableAutoRefresh();
    } else {
      enableAutoRefresh();
    }
  }, [isExpanded, disableAutoRefresh, enableAutoRefresh]);

  return (
    <Block
      css={{
        align: ["column", "left", "middle"],
        width: "100%",
        iframe: {
          mb: isExpanded ? "$4" : "$0",
          height: isExpanded ? "320px" : "120px",
          width: isExpanded ? "100%" : "360px",
        },
        "@lg": {
          mt: "$0",
          iframe: {
            height: isExpanded ? "720px" : "120px",
            width: isExpanded ? "100%" : "360px",
          },
        },
      }}
    >
      <Block
        css={{
          align: ["row", "left", "top"],
          mb: isExpanded ? "$0" : "$0",
          width: "100%",
        }}
      >
        {isArray(props?.contentData) && props?.contentData.length > 0 && (
          <Thumbnail
            src={`${props?.contentData[0]?.url}?&f=3x2`}
            alt={props?.contentData.byline}
            onClick={handleExpand}
            style={{
              cursor: "pointer",
              display: isExpanded ? "none" : "block",
            }}
          />
        )}
        <Block
          css={{
            align: ["column", "left", "top"],
            ml: isExpanded ? "$0" : "$4",
            width: "calc(100% - $4)",
          }}
        >
          {isExpanded ? (
            <>
              <Block
                css={{
                  display: "none",
                  width: "100%",
                  "@lg": {
                    align: ["column", "between", "top"],
                    display: isExpanded ? "flex" : "none",
                  },
                }}
              >
                <SectionTitle
                  leftIcon={false}
                  isExpanded={isExpanded}
                  isVideoBox
                  rightIcon={false}
                  rightClick={handleExpand}
                  titleLabel=""
                  titleIcon="IcEconomia"
                />
                <Typography as="p" css={{ ...SubjectProps, mt: "-$8" }}>
                  Ao vivo
                </Typography>
              </Block>
              <Block
                css={{
                  align: ["row", "between", "top"],
                  ml: "$2",
                  width: "100%",
                  "@lg": {
                    display: "none",
                  },
                }}
              >
                <Typography as="p" css={SubjectProps}>
                  Ao vivo
                </Typography>
                <Typography as="p" css={CloseProps} onClick={handleExpand}>
                  X
                </Typography>
              </Block>
            </>
          ) : (
            <Block
              css={{
                width: "100%",
                "@lg": {
                  align: ["column", "left", "between"],
                  height: "90px",
                },
              }}
            >
              <Typography as="p" css={SubjectProps}>
                Ao vivo
              </Typography>
              <Typography as="h2" css={TitleProps} onClick={handleExpand}>
                {props?.title || props?.name}
              </Typography>
            </Block>
          )}
        </Block>
        <Block
          css={{
            align: ["column", "left", "middle"],
            display: "none",
            ml: "$2",
            height: "100px",
            width: "260px",
            "@lg": {
              display: isExpanded ? "none" : "flex",
            },
          }}
        >
          <Typography
            as="h2"
            css={TitleOpenProps}
            onClick={handleExpand}
            id="expandir-ao-vivo"
          >
            CLIQUE PARA EXPANDIR
          </Typography>
        </Block>
      </Block>
      {isExpanded && (
        <>
          <VideoWrap {...props} />
          <Block
            css={{
              align: ["row", "between", "middle"],
              width: "100%",
            }}
          >
            <Typography as="h2" css={TitlePropsExpanded}>
              {props?.title || props?.name}
            </Typography>
            <Typography
              as="h2"
              css={TitleOpenProps}
              onClick={handleExpand}
              id="retrair-ao-vivo"
            >
              CLIQUE PARA RETRAIR
            </Typography>
          </Block>
        </>
      )}
    </Block>
  );
};

export default VideoLive;
